import TeamsList from "./TeamsList";

const AllTeamsScoresView = ({
  teams,
  onScoreUpdate,
  onTeamDelete,
  onVerificationChange,
  calculatingTotals,
  getCalculationResult,
  onInsertTeam,
  tournamentId,
  squadId,
  squads,
  events,
  canManage,
  canEnterScores,
  isPayoutFinalized,
  canVerifyTeamForEdit,
  verificationStatus,
  isScoreSaving,
  onReview,
  onRecapDelete,
  importedTeamIds = [],
}) => {
  if (!teams || teams.length === 0) {
    return (
      <div className="text-center py-8">
        <p className="text-brand-muted">No teams found.</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <TeamsList
        teams={teams}
        onScoreUpdate={onScoreUpdate}
        onTeamDelete={onTeamDelete}
        onVerificationChange={onVerificationChange}
        calculatingTotals={calculatingTotals}
        getCalculationResult={getCalculationResult}
        onInsertTeam={onInsertTeam}
        tournamentId={tournamentId}
        squadId={squadId}
        squads={squads}
        events={events}
        canManage={canManage}
        canEnterScores={canEnterScores}
        isPayoutFinalized={isPayoutFinalized}
        canVerifyTeamForEdit={canVerifyTeamForEdit}
        verificationStatus={verificationStatus}
        isScoreSaving={isScoreSaving}
        onReview={onReview}
        onRecapDelete={onRecapDelete}
        importedTeamIds={importedTeamIds}
      />
    </div>
  );
};

export default AllTeamsScoresView;
